import React, { useState } from 'react';
import showAlert from '../../../common/utils/alert';
import UpdateEnvConstantValue from './UpdateEnvConstantValue';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

const ShowEnvConstantTable = ({
  envId,
  projectId,
  version,
  constant,
  appSetting,
  actions,
  deleteFlag,
  envType,
}) => {
  const [showForm, setShowForm] = useState(false);

  const { isExternalDataSource, uuid } = constant || {};

  const handleSubmit = (constantValue) => {
    actions
      .updateEnvConstant({ envId, projectId, version, uuid: constant.uuid, value: constantValue })
      .then(() => {
        setShowForm(false);
        window.location.reload();
      });
  };
  const deleteEnvConstant = () => {
    const { uuid, isExternalDataSource } = constant || {};
    console.log(
      '🚀 ~ deleteEnvConstant ~ constant:',
      constant,
      'uuid:',
      uuid,
      'isExternalDataSource:',
      isExternalDataSource,
    );

    const preConfirm = () => {
      actions.removeEnvConstant({ envId, projectId, version, uuid: constant.uuid }).then(() => {
        window.location.reload();
      });
    };

    const preConfirmAlert = () => {
      showAlert('This will remove key from all the environments', preConfirm, 'Yes, delete it!');
    };

    if (isExternalDataSource) {
      showAlert(
        `This key is linked with Data Source, deleting it can cause issues with Data Source's External APIs. Do you want to proceed?`,
        preConfirmAlert,
        'Yes, continue!',
      );
    } else {
      preConfirmAlert();
    }
  };
  const showEnvConstantFormTable = (constant) => {
    const { updateEnvConstantPending } = appSetting;
    return (
      <UpdateEnvConstantValue
        constant={constant}
        showForm={showForm}
        setShowForm={() => setShowForm(!showForm)}
        handleSubmit={handleSubmit}
        updateEnvConstantPending={updateEnvConstantPending}
      />
    );
  };

  const showConstantValue = () => {
    if (!constant.value) {
      return '';
    }

    return (
      <textarea
        className="w-100 p-2"
        disabled
        rows={constant.value.length / 30}
        value={constant.value}
      ></textarea>
    );
  };
  return (
    <tr key={constant.uuid + envType}>
      <td width="25%">
        {constant.name}
        {isExternalDataSource && (
          <div>
            <small>(from Data Source)</small>
          </div>
        )}
      </td>
      <td width="50%">{showConstantValue()}</td>
      <td width="20%">
        {showEnvConstantFormTable(constant)}
        <button className="btn btn-xs btn-theme-submit" onClick={() => setShowForm(!showForm)}>
          <i className="wb webconnect-pencil"> </i>
        </button>
        &nbsp;
        <button
          type="button"
          className="btn btn-xs btn-theme-delete"
          style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
          onClick={deleteFlag ? deleteEnvConstant : undefined}
        >
          <i className="wb webconnect-trash-solid"> </i>
          {deleteFlag ? null : (
            <>
              &nbsp;
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            </>
          )}
        </button>
      </td>
    </tr>
  );
};

export default ShowEnvConstantTable;
